import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SecondaryLogoComponent } from '@app/components/shared/secondary-logo/secondary-logo.component';
import { AppRoutes } from '@app/utils/enums/routes.enum';

@Component({
  selector: 'app-reset-pass-congratulations',
  standalone: true,
  imports: [SecondaryLogoComponent, TranslateModule, RouterModule],
  templateUrl: './reset-pass-congratulations.component.html',
  styleUrl: './reset-pass-congratulations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPassCongratulationsComponent {
  public appRoutes: typeof AppRoutes = AppRoutes;
}
